import React, { useState } from 'react';
import { CopyIcon, RssIcon, KeyIcon, UsersIcon } from 'lucide-react';
export function Settings() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [feedEnabled, setFeedEnabled] = useState(false);
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('');
  const feedUrl = 'https://api.nordot.com/feed/your-unique-id';
  const handleCopyFeed = () => {
    navigator.clipboard.writeText(feedUrl);
    alert('Feed link copied to clipboard!');
  };
  const handleAddUser = () => {
    if (email && role) {
      alert(`User ${email} added with role: ${role}`);
      setEmail('');
      setRole('');
    }
  };
  return <div className="space-y-8" data-id="element-377">
      {/* Header */}
      <div data-id="element-378">
        <h1 className="text-4xl font-bold text-display text-neutral-900 mb-2" data-id="element-379">
          Settings
        </h1>
        <p className="text-lg text-neutral-600" data-id="element-380">
          Configure your RSS feed, authentication, and user access
        </p>
      </div>
      {/* Account Management Section */}
      <div className="bg-white rounded-xl p-8 shadow-card border border-neutral-200" data-id="element-381">
        <div className="flex items-center gap-3 mb-6" data-id="element-382">
          <UsersIcon className="w-6 h-6 text-primary-600" data-id="element-383" />
          <h2 className="text-2xl font-bold text-display text-neutral-900" data-id="element-384">
            Account Management
          </h2>
        </div>
        <p className="text-neutral-600 mb-6" data-id="element-385">
          Manage user access and permissions
        </p>
        <div className="space-y-6" data-id="element-386">
          <div className="grid grid-cols-2 gap-6" data-id="element-387">
            <div data-id="element-388">
              <label className="block text-sm font-semibold text-neutral-700 mb-2" data-id="element-389">
                Email Address
              </label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="user@example.com" className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all" data-id="element-390" />
            </div>
            <div data-id="element-391">
              <label className="block text-sm font-semibold text-neutral-700 mb-2" data-id="element-392">
                Role
              </label>
              <select value={role} onChange={e => setRole(e.target.value)} className="w-full px-4 py-3 border border-neutral-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all" data-id="element-393">
                <option value="" data-id="element-394">Select a role</option>
                <option value="admin" data-id="element-395">Admin</option>
                <option value="editor" data-id="element-396">Editor</option>
                <option value="viewer" data-id="element-397">Viewer</option>
              </select>
            </div>
          </div>
          <button onClick={handleAddUser} className="px-8 py-3 text-white rounded-lg transition-all font-medium shadow-sm" style={{
          background: 'linear-gradient(135deg, #26aedb 0%, #0289BB 50%, #0277a8 100%)'
        }} onMouseEnter={e => e.currentTarget.style.opacity = '0.9'} onMouseLeave={e => e.currentTarget.style.opacity = '1'} data-id="element-398">
            Add User
          </button>
        </div>
      </div>
      {/* RSS Feed Section */}
      <div className="bg-white rounded-xl p-8 shadow-card border border-neutral-200" data-id="element-399">
        <div className="flex items-center gap-3 mb-6" data-id="element-400">
          <RssIcon className="w-6 h-6 text-primary-600" data-id="element-401" />
          <h2 className="text-2xl font-bold text-display text-neutral-900" data-id="element-402">
            RSS Feed Integration
          </h2>
        </div>
        <p className="text-neutral-600 mb-6" data-id="element-403">
          Generate an RSS feed link to integrate republished content with your
          publishing system
        </p>
        <div className="bg-neutral-50 rounded-lg p-6 border border-neutral-200" data-id="element-404">
          <div className="flex items-center justify-between gap-4" data-id="element-405">
            <div className="flex-1 min-w-0" data-id="element-406">
              <p className="text-sm font-semibold text-neutral-700 mb-1" data-id="element-407">
                Feed URL
              </p>
              <p className="text-sm text-neutral-600 font-mono truncate" data-id="element-408">
                {feedUrl}
              </p>
            </div>
            <button onClick={handleCopyFeed} className="flex items-center gap-2 px-5 py-2.5 text-white rounded-lg transition-all font-medium text-sm shadow-sm flex-shrink-0" style={{
            background: 'linear-gradient(135deg, #26aedb 0%, #0289BB 50%, #0277a8 100%)'
          }} onMouseEnter={e => e.currentTarget.style.opacity = '0.9'} onMouseLeave={e => e.currentTarget.style.opacity = '1'} data-id="element-409">
              <CopyIcon className="w-4 h-4" data-id="element-410" />
              Copy Link
            </button>
          </div>
        </div>
      </div>
      {/* Authentication Section */}
      <div className="bg-white rounded-xl p-8 shadow-card border border-neutral-200" data-id="element-411">
        <div className="flex items-center gap-3 mb-6" data-id="element-412">
          <KeyIcon className="w-6 h-6 text-primary-600" data-id="element-413" />
          <h2 className="text-2xl font-bold text-display text-neutral-900" data-id="element-414">
            Feed Authentication
          </h2>
        </div>
        <p className="text-neutral-600 mb-6" data-id="element-415">
          Add authentication credentials to secure your RSS feed
        </p>
        <div className="space-y-6" data-id="element-416">
          <div className="grid grid-cols-2 gap-6" data-id="element-417">
            <div data-id="element-418">
              <label className="block text-sm font-semibold text-neutral-700 mb-2" data-id="element-419">
                Username
              </label>
              <input type="text" value={username} onChange={e => setUsername(e.target.value)} placeholder="Enter username" className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all" data-id="element-420" />
            </div>
            <div data-id="element-421">
              <label className="block text-sm font-semibold text-neutral-700 mb-2" data-id="element-422">
                Password
              </label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter password" className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all" data-id="element-423" />
            </div>
          </div>
          <div className="pt-4" data-id="element-424">
            <button onClick={() => setFeedEnabled(!feedEnabled)} className="w-full py-4 text-white rounded-lg font-semibold transition-all shadow-sm" style={{
            background: 'linear-gradient(135deg, #26aedb 0%, #0289BB 50%, #0277a8 100%)'
          }} onMouseEnter={e => e.currentTarget.style.opacity = '0.9'} onMouseLeave={e => e.currentTarget.style.opacity = '1'} data-id="element-425">
              {feedEnabled ? 'Feed Enabled' : 'Enable Feed'}
            </button>
          </div>
        </div>
      </div>
    </div>;
}